// Controllo formale Partita IVA italiana: 11 cifre + cifra di controllo (algoritmo di Luhn modificato).
export function validatePIVA(raw) {
  const p = (raw || "").replace(/\s+/g, "");
  if (!p) return { ok: true, empty: true };
  if (!/^\d{11}$/.test(p)) return { ok: false, error: "La Partita IVA deve contenere 11 cifre" };
  let s = 0;
  for (let i = 0; i < 10; i++) {
    let d = +p[i];
    if (i % 2 === 1) { d *= 2; if (d > 9) d -= 9; }
    s += d;
  }
  return (10 - (s % 10)) % 10 === +p[10] ? { ok: true } : { ok: false, error: "Partita IVA non valida (cifra di controllo errata)" };
}
